import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import { ApiNotificationCause } from "@/generated/models/ApiNotificationCause";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { INotificationIdentityNic, INotificationIdentityRep } from "@/types/feed.types";
import Link from "next/link";
import { useContext } from "react";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import NotificationHeader from "../subcomponents/NotificationHeader";
import NotificationTimestamp from "../subcomponents/NotificationTimestamp";
interface NotificationIdentityRatingProps {
  readonly notification: INotificationIdentityRep | INotificationIdentityNic;
}
function getRatingColor(rating: number): string {
  if (rating > 0) return "tw-text-green";
  if (rating < 0) return "tw-text-red";
  return "tw-text-iron-400";
}
function formatRating(rating: number): string {
  const prefix = rating > 0 ? "+" : "";
  return `${prefix}${formatNumberWithCommas(rating)}`;
}
export default function NotificationIdentityRating(t0) {
  const $ = _c(27);
  const {
    notification
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const isRep = notification.cause === ApiNotificationCause.IdentityRep;
  const {
    amount,
    total
  } = notification.additional_context;
  const category = "category" in notification.additional_context ? notification.additional_context.category : null;
  const myHandle = connectedProfile?.handle;
  let t1;
  if ($[0] !== isRep || $[1] !== myHandle) {
    t1 = () => {
      if (!myHandle) {
        return null;
      }
      return isRep ? `/${myHandle}/rep` : `/${myHandle}/identity`;
    };
    $[0] = isRep;
    $[1] = myHandle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getProfileLink = t1;
  const linkHref = getProfileLink();
  const ratingLabel = isRep ? "REP" : "NIC";
  const t2 = notification.related_identity;
  let t3;
  if ($[3] !== notification.related_identity) {
    t3 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
    $[3] = notification.related_identity;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-text-sm tw-font-normal tw-text-iron-400">updated your{" "}</span>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== amount || $[7] !== category || $[8] !== linkHref || $[9] !== ratingLabel) {
    t5 = linkHref ? <Link href={linkHref} className="tw-text-sm tw-no-underline hover:tw-underline"><span className="tw-font-medium tw-text-iron-300">{ratingLabel}</span>{category && <span className="tw-font-normal tw-text-iron-400">{" "}for category '{category}'</span>}<span className="tw-font-normal tw-text-iron-400"> by </span><span className={`tw-font-medium ${getRatingColor(amount)}`}>{formatRating(amount)}</span></Link> : <span className="tw-text-sm"><span className="tw-font-medium tw-text-iron-300">{ratingLabel}</span>{category && <span className="tw-font-normal tw-text-iron-400">{" "}for category '{category}'</span>}<span className="tw-font-normal tw-text-iron-400"> by </span><span className={`tw-font-medium ${getRatingColor(amount)}`}>{formatRating(amount)}</span></span>;
    $[6] = amount;
    $[7] = category;
    $[8] = linkHref;
    $[9] = ratingLabel;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-mr-1 tw-text-xs tw-font-bold tw-text-iron-400">•</span>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== total) {
    t7 = getRatingColor(total);
    $[12] = total;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `tw-font-medium ${t7}`;
  let t9;
  if ($[14] !== total) {
    t9 = formatNumberWithCommas(total);
    $[14] = total;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <span className="tw-whitespace-nowrap tw-text-sm tw-font-normal tw-text-iron-400">{t6}New Total:{" "}<span className={t8}>{t9}</span></span>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== notification.created_at) {
    t11 = <NotificationTimestamp createdAt={notification.created_at} />;
    $[19] = notification.created_at;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== notification.related_identity || $[22] !== t10 || $[23] !== t11 || $[24] !== t3 || $[25] !== t5) {
    t12 = <div className="tw-w-full"><NotificationHeader author={t2} actions={t3}>{t4}{t5}{t10}{t11}</NotificationHeader></div>;
    $[21] = notification.related_identity;
    $[22] = t10;
    $[23] = t11;
    $[24] = t3;
    $[25] = t5;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}